const config = {
    apiBaseUrl:"https://azglass.vercel.app",
}


export default config;